import React, { useEffect, useState } from 'react'
import { getYear } from 'date-fns';
import { getTalentTagOptions } from 'reducers/companyTalent';
import { setIsOpenSearchTagsPanel } from "reducers/talentTag";
import { range } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { WORKING_AGE } from '../../../../constants'
import TextInput from '../../../../components/TextInput';
import Dropdown from '../../../../components/Dropdown';
import CustomDatePicker from '../../../../components/CustomDatePicker';
import { useNavigate } from 'react-router-dom';

const BasicInfoSection = ({ handleSearchTalent, formAdvanceData, setFormAdvanceData, handleChange }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { typeOptions, talentTagOptions, cityOptions, genderOptions } = useSelector((state: any) => state.companyTalent);
  const [searchTagQuery, setSearchTagQuery] = useState("");
  const rangeYears = range(getYear(new Date()) - WORKING_AGE, getYear(new Date()) - 101, -1);

  const getMinDateOfBirth = () => {
    if(formAdvanceData.date_of_birth_start) {
      return formAdvanceData.date_of_birth_start
    }
    return new Date(2000, new Date().getMonth(), new Date().getDate())
  };

  const getMaxDateOfBirth = () => {
    if(formAdvanceData.date_of_birth_end) {
      return formAdvanceData.date_of_birth_end
    }
    return new Date()
  };

  const handleChangeAge = (value, name) => {
    let age = value.replace(/\D/g, "");
    setFormAdvanceData((prev) => ({
      ...prev,
      [name]: age,
    }));
    return;
  }

  useEffect(() => {
    dispatch(getTalentTagOptions({searchQuery: searchTagQuery}));
  }, [searchTagQuery]);

  return (
    <>
      <p className='text-sm font-bold alu-text-base-2 mb-6'>基本情報</p>
      <div className='flex flex-col gap-8'>
        <div className='flex gap-10'>
          <div className="flex-1">
            <label className="block text-sm mb-2 alu-text-base-1">氏名・タレントID</label>
            {/* name */}
            <TextInput
              size="md"
              name="name"
              value={formAdvanceData.name}
              onChange={handleChange}
              onKeyDown={(e: any) => e.key === "Enter" && handleSearchTalent(e)}
              placeholder=""
              maxLength={201}
              clearIcon={true}
              onClearQuery={() => {
                setFormAdvanceData((prev: any) => ({
                  ...prev,
                  name: '',
                }));
              }}
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm mb-2 alu-text-base-1">タレント種別</label>
            {/* type */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={typeOptions}
              placeholder=""
              value={formAdvanceData.type}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, type: value }))
              }}
              multiple={true}
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm mb-2 alu-text-base-1">メールアドレス</label>
            {/* email */}
            <TextInput
              size="md"
              name="email"
              value={formAdvanceData.email}
              onChange={handleChange}
              onKeyDown={(e: any) => e.key === "Enter" && handleSearchTalent(e)}
              placeholder=""
              maxLength={254}
              clearIcon={true}
              onClearQuery={() => {
                setFormAdvanceData((prev: any) => ({
                  ...prev,
                  email: '',
                }));
              }}
            />
          </div>
        </div>
        <div className='grid grid-cols-4 gap-10'>
          <div className="col-span-3">
            <label className="block text-sm mb-2 alu-text-base-1">タグ</label>
            <div className="flex items-start gap-2">
              {/* tags */}
              <div className='flex-1'>
                <Dropdown
                  clearable={true}
                  inputWidth="full"
                  options={talentTagOptions}
                  placeholder=""
                  value={formAdvanceData.tags}
                  onChange={(value: any) => {
                    setFormAdvanceData((prev) => ({ ...prev, tags: value }))
                  }}
                  multiple={true}
                  havingIcon={false}
                  searchInput={true}
                  searchQuery={searchTagQuery}
                  setSearchQuery={setSearchTagQuery}
                  customStyle='!max-h-full'
                  isMinHeight={true}
                  isValuesTruncated={false}
                  noOptionsFoundText={searchTagQuery ? '指定した条件のタグは見つかりませんでした' : 'タグが登録されていません'}
                  optionStyles='px-2 py-[0.125rem] rounded-sm bg-[#F7F7F7] text-center'
                  actionsButton={[{ name: 'タグ管理', variant: 'outline', handleClick: () => {dispatch(setIsOpenSearchTagsPanel(false)); navigate('/company/talent/tags')}}]}
                />
              </div>
              <div className='w-[152px] shrink-0'>
                <Dropdown
                  inputWidth="full"
                  options={[{name: 'すべて含む', id: 'and'}, {name: 'いずれかを含む', id: 'or'}, {name: 'すべて含まない', id: 'none_of'}]}
                  placeholder=""
                  value={formAdvanceData.tag_condition}
                  onChange={(value: any) => {
                    setFormAdvanceData((prev) => ({ ...prev, tag_condition: value }))
                  }}
                />
              </div>
            </div>
          </div>
          <div className='col-span-1'></div>
        </div>
        <div className='grid grid-cols-4 gap-10'>
          <div className="col-span-2">
            <label className="block text-sm mb-2 alu-text-base-1">生年月日</label>
            <div className='flex items-center gap-2'>
              <div className='flex-1'>
                <CustomDatePicker
                  placeholderText=""
                  value={formAdvanceData.date_of_birth_start}
                  maxDate={getMaxDateOfBirth()}
                  yearsInput={rangeYears}
                  onChange={(value: any) => {
                    setFormAdvanceData((prev) => ({ ...prev, date_of_birth_start: value }))
                  }}
                />
              </div>
              <span className='shrink-0'>-</span>
              <div className='flex-1'>
                <CustomDatePicker
                  placeholderText=""
                  value={formAdvanceData.date_of_birth_end}
                  minDate={getMinDateOfBirth()}
                  maxDate={new Date()}
                  yearsInput={rangeYears}
                  onChange={(value: any) => {
                    setFormAdvanceData((prev) => ({ ...prev, date_of_birth_end: value }))
                  }}
                />
              </div>
            </div>
          </div>

          <div className='col-span-2'>
            <label className="block text-sm mb-2 alu-text-base-1">年齢</label>
            {/* age_rank */}
            <div className='flex items-center gap-2'>
              <div className='w-[80px]'>
                <TextInput
                  clearIcon={true}
                  size="md"
                  type="number"
                  min={1}
                  max={100}
                  id="from_income"
                  name="from_income"
                  value={formAdvanceData.age_from}
                  onChange={(e: any) => handleChangeAge(e.target.value, 'age_from')}
                  onClearQuery={() => handleChangeAge('', 'age_from')}
                  onKeyDown={(e: any) => e.key === "Enter" && handleSearchTalent(e)}
                  placeholder=""
                  maxLength={3}
                />
              </div>
              <span>-</span>
              <div className='w-[80px]'>
                <TextInput
                  clearIcon={true}
                  size="md"
                  type="number"
                  min={1}
                  max={100}
                  id="from_income"
                  name="from_income"
                  value={formAdvanceData.age_to}
                  onChange={(e: any) => handleChangeAge(e.target.value, 'age_to')}
                  onClearQuery={() => handleChangeAge('', 'age_to')}
                  onKeyDown={(e: any) => e.key === "Enter" && handleSearchTalent(e)}
                  placeholder=""
                  maxLength={3}
                />
              </div>
              <p className='text-sm'>歳</p>
            </div>
          </div>
        </div>

        <div className='grid grid-cols-4 gap-10'>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">居住地</label>
            {/* city */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={cityOptions}
              placeholder=""
              value={formAdvanceData.city}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, city: value }))
              }}
              multiple={true}
            />
          </div>
          <div className='col-span-1'>
            <label className="block text-sm mb-2 alu-text-base-1">性別</label>
            {/* gender */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={genderOptions}
              placeholder=""
              value={formAdvanceData.gender}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, gender: value }))
              }}
            />
          </div>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">登録リンクコード</label>
            {/* register_code */}
            <TextInput
              size="md"
              name="register_code"
              value={formAdvanceData.register_code}
              onChange={handleChange}
              onKeyDown={(e: any) => e.key === "Enter" && handleSearchTalent(e)}
              placeholder=""
              maxLength={6}
              clearIcon={true}
              onClearQuery={() => {
                setFormAdvanceData((prev: any) => ({
                  ...prev,
                  register_code: '',
                }));
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default BasicInfoSection